module.exports = __webpack_public_path__ + "img/ui-documentation-preview.4b2ed89a.png";